import {makeStyles} from '@material-ui/core/styles'
import GroupCreateModalBase from '../../2compounds/GroupCreateModalBase'
import {useEffect, useState} from 'react'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction'
import ListItemText from '@mui/material/ListItemText'
import IconButton from '@mui/material/IconButton'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import BusinessSearch from '../../2compounds/BusinessSearch'

const SelectBusinessesModal = ({open, setOpen, businesses, setBusinesses}) => {
    const classes = useStyles()
    const [businessesTemp, setBusinessesTemp] = useState(null)
    const [businessesListTemp, setBusinessesListTemp] = useState([])

    const cancelHandler = () => {
        setOpen(false)
    }

    const saveHandler = () => {
        setBusinesses(businessesListTemp)
        setOpen(false)
    }

    const onChangeHandler = (newValue) => {
        const copy = [...businessesListTemp]
        copy.push(newValue)
        setBusinessesListTemp(copy)
        setBusinessesTemp(null)
    }

    const deleteHandler = (index) => {
        const copy = [...businessesListTemp]
        copy.splice(index, 1)
        setBusinessesListTemp(copy)
    }

    useEffect(()=>{
        setBusinessesListTemp(businesses)
    }, [businesses, open])

    return (
        <GroupCreateModalBase header='Assign businesses'
                              saveHandler={saveHandler}
                              cancelHandler={cancelHandler}
                              open={open}
                              setOpen={setOpen}>
            <BusinessSearch selectedClient={businessesTemp} setSelectedClient={onChangeHandler} selectedClientList={businessesListTemp} />

            <div className={classes.listDiv}>
                <List>
                    {
                        businessesListTemp.map((business, index)=>(
                            <ListItem key={index}>
                                <ListItemText primary={business.name} />
                                <ListItemSecondaryAction>
                                    <IconButton edge="end" aria-label="delete" onClick={(index)=>deleteHandler(index)}>
                                        <HighlightOffIcon />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItem>
                        ))
                    }
                </List>
            </div>
        </GroupCreateModalBase>
    )
}

export default SelectBusinessesModal

const useStyles = makeStyles({
    root: {},
    listDiv: {
        height: '300px',
        overflowY: 'auto'
    }
})
